export default {
  online_payments_off:
    'Delivery is switched on, but customers can’t order it: courier delivery is paid online only, and online payments are switched off.',
  gateway_not_verified:
    'Delivery is switched on, but customers can’t order it: courier delivery is paid online only, and online payments are paused until your payment account is verified.',
  stripe_processing_fee_missing:
    'Delivery is switched on, but customers can’t order it: courier delivery is paid online only, and online payments are paused until your partner sets its processing fee.',
  turn_on_online_payments: 'Turn on online payments',
};
